import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import IdleTimer from 'react-idle-timer'
import ConfirmationDialog from '../portal/dialogs/confirmationDialog';
import { ButtonType } from '@checkmarx/cx-ui';

@inject('translationsStore', 'oidcStore') @observer
export default class SessionMonitor extends Component {
    
    render(){
        
        return (
            <div>
                <IdleTimer
                onIdle={this.setUserIdle}
                timeout={this.props.sessionTimeout} />
                <ConfirmationDialog 
                        open={this.props.oidcStore.isUserIdle}
                        onButtonClick={this.handleSessionRenewal}
                        buttonText={this.props.translationsStore.translate('OK')}
                        titleText={this.props.translationsStore.translate('SESSION_TIMEOUT_TITLE')}
                        contentText={this.formatSessionTimeoutMessage()}
                        inProgress={this.props.oidcStore.isSessionRenewInProgress}
                        displayCloseButton={false}
                        />
            </div>
        );
    }
    
    formatSessionTimeoutMessage = () => {
        
        const sessionTimeoutMessageFormated =
                    <div>
                        <div>
                            {this.props.translationsStore.translate('SESSION_TIMEOUT_MESSAGE_FIRST_LINE')}
                        </div>
                        <div>
                            {this.props.translationsStore.translate('SESSION_TIMEOUT_MESSAGE_SECOND_LINE')}
                        </div>
                    </div>;
        
        return sessionTimeoutMessageFormated;
    }

    setUserIdle = () => {
        
        if(this.props.oidcStore.currentUser){
            this.props.oidcStore.setUserIdle(true);
        }
    }

    handleSessionRenewal = () => {
        
        this.props.oidcStore.setSessionRenewInProgress(true);
        this.props.oidcStore.startSilentRenew().then(() => {
            this.props.oidcStore.setUserIdle(false);
            this.props.oidcStore.setSessionRenewInProgress(false);
        }).catch(() => {
            this.props.oidcStore.reloadPageWithNewToken();
        })
    }
}